
import Rates from "@/components/rates";
export default {
  name: "productlistgrid",
  components: {Rates},
  methods: {
    setTitle(title) {
      document.title = title + ' | Tirelet'
    },
    showModal() {
      this.$nuxt.$emit('openCityModal')
    },
  },
  props: {
    id: "",
    image: {
      type: String,
      default: ''
    },
    brandImage: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    dealerName: {
      type: String,
      default: ''
    },
    dealerLocation: {
      type: String,
      default: ''
    },
    dealerSlug: {
      type: String,
      default: ''
    },
    barcode:{
      type:String,
      default: ''
    },
    salePrice: {
      type: Number,
      default: 0
    },
    discountPrice: {
      type: Number,
      default: 0
    },
    four_product_price:{
      type: Number,
      default: 0
    },
    listPrice: {
      type: Number,
      default: 0
    },
    quantity: {
      type: Number,
      default: 0
    },
    slug: {
      type: String,
      default: ''
    },
    fuelTag: {
      type: String,
      default: "",
    },
    wetTag: {
      type: String,
      default: "",
    },
    noiseTag: {
      type: String,
      default: "",
    },
    seasonTag: {
      type: String,
      default: "",
    },
    score: {
      type: Number,
      default: 0
    },
    feedbackScore: {
      type: Number,
      default: 0
    },
    categoryName: {
      type: String,
      default: ''
    },
    categoryDescription: {
      type: String,
      default: ''
    },
    brandName: {
      type: String,
      default: ''
    },
    brandSlug: {
      type: String,
      default: ''
    },
    feedbackCount: {
      type: Number,
      default: 0
    },
    serviceDiscount: {
      type: Boolean,
      default: false
    },
    bestSeller: {
      type: Boolean,
      default: false
    },
  }
}
